<div class="search-container">
  <input
    #searchInput
    class="search-input"
    type="text"
    [placeholder]="placeholder"
    [attr.aria-label]="ariaLabel"
    [value]="value"
    (input)="handleSearchChanged($event)" />
  <button type="button" class="reset-button" [hidden]="!value" (click)="reset()" i18n>
    <img [src]="'assets/icons/grey/X.svg'" alt="Clear input" i18n-alt height="24" width="24" />
  </button>
</div>
